
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class DatePickers extends Vue {
    @Prop({default: ''}) minLimit?: string
    @Prop({default: ''}) maxLimit?: string
    @Prop({default: ''}) show!: boolean
    @Prop({default: false}) readonly!: boolean
    @Prop({default: false}) title!: boolean
    @Prop({default: ''}) defaultDate!: string

    minDate  = new Date(dayjs().subtract(100, 'year').format('YYYY-MM-DD')) // 默认100年前
    maxDate  = new Date(dayjs().add(100, 'year').format('YYYY-MM-DD')) // 默认100年后
    currentDate = new Date()

    @Watch('show')
    showDate (val: boolean) {
        if (!val) return

        if (this.$checkIsEmpty(this.defaultDate)) {
            this.currentDate = new Date()
        } else {
            this.currentDate = new Date(this.defaultDate)
        }

        if (this.$checkIsEmpty(this.minLimit)) {
            this.minDate = new Date(dayjs().subtract(100, 'year').format('YYYY-MM-DD')) // 默认100年前
        } else {
            this.minDate = new Date(this.minLimit)
        }

        if (this.$checkIsEmpty(this.maxLimit)) {
            this.maxDate = new Date(dayjs().add(100, 'year').format('YYYY-MM-DD')) // 默认100年后
        } else {
            this.maxDate = new Date(this.maxLimit)
        }
    }

    clearTime (type: number) {
        this.$emit('clearTimeData')
        this.$emit('popupClose')
    }

    popupClose () {
        this.$emit('popupClose')
    }

    changeDate () {
        this.$emit('onConfirmData', dayjs(this.currentDate).format('YYYY-MM-DD'))
        this.$emit('popupClose')
    }

}
